module.exports = __webpack_public_path__ + "img/m_main.b6428e63.jpg";